// @flow

import { combineEpics } from 'redux-observable';
import { websocketEpics } from './websocketEpics';
import { contentEpics } from './contentEpics';
import { i18nEpics } from './i18nEpics';
import { commonEpics } from './commonEpics';
import { userRegistrationEpics } from './userRegistrationEpics';
import { depositEpics } from './depositEpics';
import { franceConnectEpics } from './franceConnectEpics';
import { sessionEpics } from './sessionEpics';
import { landingEpics } from './landingEpics';
import { tagManagerEpics } from './tagManagerEpics';

export const rootEpic = combineEpics(
  websocketEpics,
  contentEpics,
  i18nEpics,
  commonEpics,
  userRegistrationEpics,
  depositEpics,
  franceConnectEpics,
  sessionEpics,
  landingEpics,
  tagManagerEpics
);
